import { baseConfig } from '@purple-dot/translations';
import allLocales from '@purple-dot/translations/locales/all';
import i18next from 'i18next';
import { useEffect } from 'react';
import {
  initReactI18next,
  useTranslation as reactUseTranslation,
  UseTranslationOptions,
} from 'react-i18next';

// Configure i18next with all supported locales and namespaces used in the frontend.
// We just import all the JSON and shove it into i18next. This is suboptimal for performance
// because e.g. the checkout now has to load language it isn't actually rendering.

if (i18next.isInitialized) {
  void i18next.use(initReactI18next).init();
} else {
  i18next
    .use(initReactI18next)
    .init({
      ...baseConfig,
      initImmediate: false,
      resources: allLocales,
      ns: ['translation', 'countries'],
    })
    // biome-ignore lint/suspicious/noConsole: log
    .catch((err) => console.error(err));
}

export function useTranslation(
  ns?: string,
  opts?: UseTranslationOptions<string> & { locale?: string }
) {
  const res = reactUseTranslation(ns ?? 'translation', opts);

  useEffect(() => {
    const queryParamLocale = new URLSearchParams(window.location.search).get(
      'locale'
    );

    const passedInLocale = opts?.locale;

    const locale =
      passedInLocale || queryParamLocale || window.navigator.language;

    if (locale) {
      // biome-ignore lint/suspicious/noConsole: old
      res.i18n.changeLanguage(locale).catch((err) => console.error(err));
    }
  }, []);

  const currentLocale = res.i18n.resolvedLanguage;

  return { ...res, currentLocale };
}
